import { Upload } from "antd";
import React, { useEffect, useMemo, useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { uploadFile } from "../../assets/svg";
import { dummyRequest } from "../../helper/helpers";

import {
  uploadFileRowsLength,
  uploadFileSize,
} from "../../constants/constants";
import LoadingSpinner from "../loadingSpinner";
import "./styles.scss";
import { FileUploadIcon } from "../../assets/svg/mobileIcon";

const { Dragger } = Upload;

const UploadFile = (props) => {
  const { setFileData, handleRemove, isReset, fileFormat, delimiter } = props;

  const { accept, allowedFormats } = useMemo(
    () => {
      if (Array.isArray(fileFormat)) {
        return {
          accept: fileFormat.map((format) => `.${format}`).join(","),
          allowedFormats: fileFormat,
        };
      } else {
        return { accept: `.${fileFormat}`, allowedFormats: [fileFormat] };
      }
    },
    [fileFormat]
  );
  const [state, setState] = useState({
    fileList: [],
    file: {},
    error: false,
    sizeError: "",
    loading: false,
  });

  useEffect(
    () => {
      if (isReset) {
        setState((st) => ({
          ...st,
          fileList: [],
          loading: false,
        }));
      }
    },
    [isReset]
  );

  useEffect(
    () => {
      if (delimiter) {
        setState((st) => ({
          ...st,
          fileList: [],
        }));
      }
    },
    [delimiter]
  );

  const fileProps = {
    name: "file",
    listType: "picture",
    multiple: false,
    accept,
    customRequest: dummyRequest(allowedFormats),
    showUploadList:
      state.sizeError !== ""
        ? {
            removeIcon: <CloseOutlined />,
          }
        : false,
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    onChange(info) {
      let list = [...info.fileList];
      list = list.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      if (info.file.status === "uploading") {
        setState((st) => ({ ...st, loading: true }));
      }
      const isError =
        info.file &&
        (info.file.status === "error" || info.file.status === "uploading")
          ? true
          : false;
      let sizeErr;
      setState((st) => {
        sizeErr = st.sizeError;
        return {
          ...st,
          fileList: list,
          error: isError,
        };
      });

      const saveFile =
        info.file.status === "done" && state.sizeError === "" ? true : false;

      if (isError && info?.file?.error) {
        sizeErr = info?.file?.error;
        setState((st) => ({ ...st, sizeError: info?.file?.error }));
        setFileData(
          isError || info.fileList.length === 0 ? [] : list,
          isError,
          sizeErr,
          saveFile
        );
        setState((st) => ({ ...st, loading: false }));
      }

      setFileData(
        isError || info.fileList.length === 0 ? [] : list,
        isError,
        sizeErr,
        saveFile
      );
    },
    onRemove: () => {
      setState((st) => ({
        ...st,
        fileList: [],
        sizeError: "",
        loading: false,
      }));
      handleRemove();
    },
    beforeUpload: (file) => {
      if (file.size > uploadFileSize) {
        setState((st) => ({
          ...st,
          sizeError: "File size has exceeded its max limit of 8MB.",
        }));
        setFileData(
          [file],
          false,
          "File size has exceeded its max limit of 8MB.",
          false
        );
      } else if (file.size === 0) {
        setState((st) => ({
          ...st,
          sizeError: "File size is too short. Please upload another file.",
        }));
        setFileData(
          [file],
          false,
          "File size is too short. Please upload another file.",
          false
        );
      } else {
        return new Promise((res) => {
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = function() {
            const match = reader.result && reader.result.match(/\r?\n/g);
            if (match && match.length >= uploadFileRowsLength) {
              setState((st) => ({
                ...st,
                sizeError:
                  "Row count has exceeded its max limit of 80k records",
                loading: false,
              }));
            } else {
              setState((st) => ({
                ...st,
                fileList: [file],
                loading: false,
              }));
            }
            res(file);
          };
        });
      }
    },
    fileList: state.fileList,
    progress: {
      strokeColor: {
        "0%": "white",
        "100%": "white",
      },
      trailColor: "white",
      strokeWidth: 0,
      showInfo: false,
      success: {
        strokeColor: "white",
      },
      status: "active",
      format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
    },
  };
  return (
    <div className="custom-file-upload-wrapper" id="custom-file-upload-wrapper">
      <Dragger className="file-uploader" {...fileProps}>
        {state.loading &&
          state.sizeError === "" && (
            <LoadingSpinner
              type="small"
              relative
              customClassName="without-background-transparent"
            />
          )}
        {state.fileList.length > 0 ? null : (
          <>
            <p className="ant-upload-drag-icon">{uploadFile}</p>
            <p className="ant-upload-text">
              Drag & Drop or
              <span className="choose-file"> Choose File</span>
            </p>
            <button className="button-secondary">
              <FileUploadIcon />
              <span className="upload-label">Upload File</span>
            </button>
          </>
        )}
      </Dragger>
    </div>
  );
};

export default UploadFile;
